
import {of as observableOf, Observable} from 'rxjs';
import {AbstractExecutionStep} from '../../../../../core/executor/abstract-execution-step';
import {ExecutionStepStatus} from '../../../../../core/executor/execution-step-status';

export class OpenAddressSecondaryMobilePhoneWindowExecutionStep extends AbstractExecutionStep {

  doExecute(): Observable<ExecutionStepStatus> {
    const payload = this.getPayload(),
      entity = payload.getValue().entity;

    if (!entity) {
      return this.getFailObservable('You need to pass entity as part of Payload value!');
    }

    return this.doOpen(entity);
  }

  private doOpen(entity: {
    secondaryMobileCountryCode: string,
    secondaryMobileAreaCode: string,
    secondaryMobileNumber: string,
    secondaryMobileExtension: string
  }): Observable<ExecutionStepStatus> {
    const phoneCountryCode = entity.secondaryMobileCountryCode || '',
      phoneAreaCode = entity.secondaryMobileAreaCode || '',
      phoneNumber = entity.secondaryMobileNumber || '',
      phoneExtension = entity.secondaryMobileExtension || '';

    const fullNumber = phoneCountryCode +
      phoneAreaCode +
      phoneNumber +
      phoneExtension;

    document.location.href = `tel:${fullNumber}`;

    return observableOf({status: true, content: null});
  }
}
